module.exports = __webpack_public_path__ + "img/import.0b1ad761.svg";